import "date-fns";
import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "../../components/UrlServicesContext";

import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  alert_background: {
    color: "#F7F00B",
    background: "#000",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
  },
  containerForm: {
    padding: "3%",
  },
}));

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function ViewProduct(props) {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [state, setState] = useState(false);
  const [imagen, setImagen] = useState("");
  const [loader, setLoader] = useState(true);

  const { urlServices, urlImgServicesProductos } = useContext(
    UrlServicesContext
  );

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleChangeEstatus = (event) => {
    const data = new FormData();
    data.append("id", props.id);
    data.append("estatus",event.target.checked);

    setState(event.target.checked);

    axios
        .post(urlServices + "routes.php?servicio=estatusProducto", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
                props.callBackRefresh(true)
            }else{
                setError(true);
                setMensaje_error('Error al cambiar estatus');
            }
          },
          (error) => {
            setError(true);
            setMensaje_error('Error al cambiar estatus');
          }
        );
  };

  useEffect(() => {
    const data = new FormData();
    data.append("id", props.id);

    const consultar = async () => {
      await axios
        .post(urlServices + "routes.php?servicio=imagenProducto", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
              setImagen(urlImgServicesProductos + response.data.result.imagen);
              setState(response.data.result.estatus === "0" ? false : true);
              setLoader(false);
            } else {
              setLoader(false);
            }
          },
          (error) => {
            setLoader(false);
            setError(true);
          }
        );
    };

    consultar();
  }, [urlServices, props.id, urlImgServicesProductos]);
  
  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <Alert
          severity="info"
          elevation={6}
          variant="filled"
          className={classes.alert_background}
        ></Alert>
        <DialogContent dividers>
          {!loader ? (
            <Fragment>
              <center>
                <img
                  src={imagen}
                  style={{border: '1px solid #F7F00B', objectFit: 'cover', width: '300px'}}
                  alt="imgProducto"
                ></img>
              </center>

              <form noValidate autoComplete="off">
                <Grid container spacing={2} className={classes.containerForm}>
                  <Grid item xs={12} md={12}>
                    <center>
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            checked={state}
                            onChange={handleChangeEstatus}
                            name="checkedB"
                          />
                        }
                        label={state? <div style={{fontWeight: 'bold'}}>Deshabilitar</div>: <div style={{fontWeight: 'bold'}}>Habilitar</div>}
                      />
                    </center>
                  </Grid>
                </Grid>
                <br></br>
                <center>
                  {error ? <Alert severity="error">{mensaje_error}</Alert> : ""}                 
                </center>
              </form>
            </Fragment>
          ) : (
            <Fragment>
              <center>
                {" "}
                <CircularProgress />
              </center>
            </Fragment>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog(true)}
            variant="contained"
            size="medium"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>    
    </Fragment>
  );
}
